import React from 'react';
import classNames from 'classnames';
import NumericInput from 'react-numeric-input';

const CurrencyInput = props => {
  const error = props.meta.touched && props.meta.error ? 'error' : '';
  const disabled = props.disabled ? 'disabled' : '';
  const errorClass = props.className + ' small error';

  return (
    <div className="form-field number">
      <label htmlFor={props.id}>{props.label}</label>
      <NumericInput
        {...props.input}
        style={false}
        min={0}
        max={10000000}
        id={props.id}
        name={props.name}
        className={classNames(error, disabled, props.className)}
        disabled={props.disabled ? true : false}
        placeholder={props.placeholder}
      />
      <p className="field-symbol">£</p>
      { props.meta.touched && props.meta.error && <p className={errorClass}>{props.meta.error}</p> }
    </div>
  );
};

CurrencyInput.propTypes = {
  input: React.PropTypes.object,
  meta: React.PropTypes.object,
};

export default CurrencyInput;



/** WEBPACK FOOTER **
 ** ./src/components/form-input-currency/index.js
 **/